var map = {
	"./DNU_KGH.jpg": 587,
	"./DNU_bike.jpg": 588,
	"./Q1 - Biking.png": 589,
	"./Q1 - City Bus.png": 590,
	"./Q1 - Driving.png": 591,
	"./Q1 - Walking.png": 592,
	"./Q2 - Arenas and Fields.png": 593,
	"./Q2 - Dog Parks.png": 594,
	"./Q2 - Restaurants.png": 595,
	"./Q2 - Waterfront.png": 596,
	"./Q3 - Childcare.png": 597,
	"./Q3 - Hospitals.png": 598,
	"./Q3 - Long-term care.png": 599,
	"./Q4 - Historic.png": 600,
	"./Q4 - Modern.png": 601,
	"./Q5 - City Park.png": 602,
	"./Q5 - Endless.png": 603,
	"./Q5 - Private Oasis.png": 604,
	"./RS10960_180508_111455_KAP_0089.jpg": 221,
	"./architecs.jpg": 605,
	"./dog.jpg": 606,
	"./downtown.jpg": 607,
	"./driving.jpg": 608,
	"./house.jpg": 609,
	"./hulahoop.jpg": 610,
	"./kayak.jpg": 611,
	"./kingston_transit.jpg": 612,
	"./market.jpg": 613,
	"./modern.jpg": 614,
	"./plane.jpg": 615,
	"./red_chairs.jpg": 616,
	"./red_house.jpg": 617,
	"./rink.jpg": 618,
	"./rocks.jpg": 619,
	"./talent_connect.png": 620,
	"./taps.jpg": 621,
	"./tug.jpg": 622,
	"./waterfront.jpg": 623,
	"./workspace.jpg": 624,
	"./yoga.jpg": 625
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 586;


//////////////////
// WEBPACK FOOTER
// ./src/components/pages/Survey/images ^\.\/.*$
// module id = 586
// module chunks = 0